import { useMemo } from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = new RegExp(`https://dbdiagram.io/(embed|d)/([\\w-]+)$`);
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const newUrl = useMemo(() => {
    const matches = URL_REGEX.exec(url);
    if (!matches || !matches[2]) return '';

    const shareId = matches[2];

    return `https://dbdiagram.io/embed/${shareId}`;
  }, [url]);

  return (
    <Portal
      url={newUrl}
      title="DBDiagram Embed"
      {...rest}
      fullHeight
      withMetadata
    />
  );
};

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'dbdiagram-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: false,
    defaultHeight: 500,
  }),
  addCommandOption: {
    title: 'DBDiagram',
    description: 'Embed a DBDiagram.',
    searchTerms: ['embed', 'dbdiagram'],
    icon: 'tabler:brand-dbdiagram',
  },
});
